const Logo = ({ variant = 'default' }: { variant?: 'default' | 'light' }) => {
  const logoSrc = variant === 'light' ? '/auditoriginal.png' : '/auditoriginal.png';

  return (
    <div className="flex items-center">
      <img
        src={logoSrc}
        alt="Audit Financier Logo"
        className="h-16 w-auto transition-opacity hover:opacity-80"
      />
    </div>
  );
};

export default Logo;